import AWSCodePipeline from './AWSCodePipeline'

export default AWSCodePipeline
